import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { ButtonWithIcon } from '@els/els-react--button';
import StructurePreview from '@Components/Results/structure/StructurePreview';

function GSFNSubstanceArticle({ substance = {}, onSubstanceSelect = () => {} }) {
  const { rxId, path, substanceNames, referencesNumber } = substance;
  const substanceName = get(substanceNames, '[0].value');

  return (
    <article className="insert-structure-from-name-substances__item">
      <div className="insert-structure-from-name-substances__item__structure">
        <StructurePreview structureId={rxId} structureName={substanceName} previewPath={[path]} />
      </div>
      <div className="insert-structure-from-name-substances__item__name">
        {substanceName && <div>{substanceName}</div>}
        {referencesNumber && <div>{referencesNumber} references</div>}
      </div>
      <div className="u-els-display-flex o-els-flex-layout--middle">
        <ButtonWithIcon
          type="tertiary"
          size="small"
          sprite="ChevronRight"
          iconRight
          onClick={() => onSubstanceSelect(substance)}
          className="e2e-insert-structure-from-name-load-template">
          Load template
        </ButtonWithIcon>
      </div>
    </article>
  );
}

GSFNSubstanceArticle.propTypes = {
  substance: PropTypes.shape({
    rxId: PropTypes.string.isRequired,
    substanceNames: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
      })
    ),
    referencesNumber: PropTypes.string,
    path: PropTypes.shape({
      url: PropTypes.string,
    }),
  }).isRequired,
  onSubstanceSelect: PropTypes.func.isRequired,
};

export default GSFNSubstanceArticle;
